<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('traffic.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'traffic' }">{{ $t('traffic.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    
    <!-- 位置地圖 -->
    <div class="row mt-3">
      <div class="col-12 text-center">
        <b-img src="https://www2.budaedu.org/official-website-data/traffic-information/map.jpg" fluid thumbnail alt="位置地圖"></b-img>
        <div class="mt-2 text-muted">
          {{ $t('traffic.text.name') }}<br>
          {{ $t('traffic.text.address') }}
        </div>
        <div class="mt-3">
          <b-button 
            href="https://www.google.com/maps/dir//%E8%B2%A1%E5%9C%98%E6%B3%95%E4%BA%BA%E4%BD%9B%E9%99%80%E6%95%99%E8%82%B2%E5%9F%BA%E9%87%91%E6%9C%83,%20100%E5%8F%B0%E5%8C%97%E5%B8%82%E4%B8%AD%E6%AD%A3%E5%8D%80%E6%9D%AD%E5%B7%9E%E5%8D%97%E8%B7%AF%E4%B8%80%E6%AE%B555%E8%99%9F" 
            target="_blank" 
            variant="primary"
            class="px-4 py-2"
          >
            <i class="fa fa-map-marker fa-lg mr-2"></i>{{ $t('traffic.button.google-map.label') }}
          </b-button>
        </div>
      </div>
    </div>

    <!-- 交通方式內容 -->
    <div class="row mt-4">
      <div class="col-12">
        <van-divider
          :style="{ color: '#8a2be2', borderColor: '#8a2be2', 'font-size': '1.5em' }"
        >{{ $t('traffic.title') }}</van-divider>
        
        <div class="traffic-content mt-3" v-if="$i18n.locale === 'tw'">
          <div class="mt-3">
            <h6>◎ 捷運</h6>
            <p>捷運板南線(藍線），【善導寺】站，出口 4、5</p>
            <ul>
              <li>由 4 號出口（有手扶梯）出站後，左轉走到杭州南路，右轉，經過 2 個紅綠燈後，步行約 8 分鐘，在左邊。</li>
              <li>由 5 號出口（樓梯）出站後，直走穿過 2 個紅綠燈後右轉，步行約 10 分鐘，在左邊。</li>
            </ul>
          </div>

          <div class="mt-3">
            <h6>◎ 公車路線</h6>
            <ul class="bus-routes">
              <li>【仁愛路二段】杭州南路上 222，253，297</li>
              <li>【仁愛杭州路口】仁愛路上 37，270，630，651，仁愛幹線(原263)</li>
              <li>【仁愛杭州路口】杭州南路上 249，253，297</li>
              <li>【臺北商大(杭州)】253</li>
              <li>【臺北商大(濟南)】208，211，222，297</li>
              <li>【成功中學(濟南)】208，211，222，297</li>
              <li>【成功中學(林森)】208，615</li>
              <li>【開南中學】22，208，295，297，671</li>
              <li>【濟南路二段】211，222</li>
              <li>【捷運善導寺站】(2號出口) 205，257，276，600，212，262，299，605，22，265，39，232，671，604，1815</li>
              <li>【華山文創園區】205，262，212，257，299，276，600，605，1815，忠孝幹線</li>
              <li>【青島林森路口】237，307，49，222，246，295，307</li>
              <li>【金山泰安街口】606</li>
              <li>【捷運台大醫院】236，251，22，208，261，227</li>
            </ul>
          </div>
        </div>

        <div class="traffic-content mt-3" v-else-if="$i18n.locale === 'en'">
          <div class="mt-3">
            <h6>◎ MRT</h6>
            <p>Bannan Line (Blue Line), Shantao Temple Station, Exit 4 or 5.</p>
            <ul>
              <li>From Exit 4 (with escalator): Turn left to Hangzhou S. Rd., turn right after leaving the station, cross 2 traffic lights, walk about 8 minutes, it is on the left.</li>
              <li>From Exit 5 (stairs): Go straight, cross 2 traffic lights, turn right, walk about 10 minutes, it is on the left.</li>
            </ul>
          </div>

          <div class="mt-3">
            <h6>◎ Bus</h6>
            <ul class="bus-routes">
              <li>[Renai Rd. Sec. 2] (Hangzhou S. Rd.) 222, 253, 297</li>
              <li>[Renai-Hangzhou Intersection] (Renai Rd.) 37, 270, 630, 651, Renai Main Line (formerly 263)</li>
              <li>[Renai-Hangzhou Intersection] (Hangzhou S. Rd.) 249, 253, 297</li>
              <li>[NTUB (Hangzhou)] 253</li>
              <li>[NTUB (Jinan)] 208, 211, 222, 297</li>
              <li>[Chenggong High School (Jinan)] 208, 211, 222, 297</li>
              <li>[Chenggong High School (Linsen)] 208, 615</li>
              <li>[Kainan High School] 22, 208, 295, 297, 671</li>
              <li>[Jinan Rd. Sec. 2] 211, 222</li>
              <li>[MRT Shandao Temple Station] (Exit 2) 205, 257, 276, 600, 212, 262, 299, 605, 22, 265, 39, 232, 671, 604, 1815</li>
              <li>[Huashan 1914 Creative Park] 205, 262, 212, 257, 299, 276, 600, 605, 1815, Zhongxiao Main Line</li>
              <li>[Intersection of Qingdao Rd. & Linsen Rd.] 237, 307, 49, 222, 246, 295, 307</li>
              <li>[Intersection of Jinshan S. Rd. & Taian St.] 606</li>
              <li>[MRT NTU Hospital] 236, 251, 22, 208, 261, 227</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { BreadcrumbPlugin, ButtonPlugin, ImagePlugin } from 'bootstrap-vue'
import { Divider } from 'vant'
import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)
Vue.use(ButtonPlugin)
Vue.use(ImagePlugin)
Vue.use(Divider)

export default {
  i18n,
  name: 'TrafficInformation',
  metaInfo() {
    return {
      title: this.$t('traffic.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: '財團法人佛陀教育基金會交通資訊、位置地圖及交通方式。'
      }]
    }
  }
}
</script>

<style scoped>
.traffic-content {
  font-size: 1.1em;
  line-height: 1.8;
  color: #333;
}
.bus-routes {
  list-style-type: none;
  padding-left: 1.5rem;
}
</style>
